<template>
  <div>
    <component v-bind:is="currentDashboard"></component>
  </div>
</template>

<script>
import DashboardPartner from "@/pages/Dashboard/DashboardPartner";
import DashboardSales from "@/pages/Dashboard/DashboardSales";
import DashboarDefault from "@/pages/Dashboard/DashboardDefault";

export default {
  components: {
    DashboardPartner,
    DashboardSales,
    DashboarDefault
  },

  data() {
    return {};
  },

  computed: {
    currentDashboard: function() {
      let roles = this.$store.state.auth.security.roles;

      // TODO - maybe store this config in a JSON file
      if (["super-admin", "admin", "sales"].some(p => roles.includes(p))) {
        return "DashboardSales";
      } else if (["partner"].some(p => roles.includes(p))) {
        return "DashboardPartner";
      } else {
        return "DashboardDefault";
      }
    }
  },

  methods: {},

  mounted() {}
};
</script>
